import * as React from 'react';
import logo from '../../../images/GMCNgine.png';
import { Heatmap } from 'src/share/components/Maps/Heatmap/Heatmap';
import { IMapCenter } from 'src/share/types/common';
import DatesChart from 'src/share/components/Chart/ChartDays';
import GDStatistic from './components/GDStatistic';
import GDTable from './components/GDTable';
import GDCarousel from './components/GDCarousel';
import { useGlobalStats } from './hooks/useGlobalStats';
import { getCurrentYear } from 'src/share/utils/utils';
import './globalDashboard.css';

const currentYear = getCurrentYear();

const GlobalDashboard = (): React.ReactElement => {
  const { stats, lastUpdate } = useGlobalStats();
  const [currenCenter, setCurrentCenter] = React.useState<IMapCenter | null>(
    null
  );
  const handleTransition = React.useCallback(
    (center) => setCurrentCenter(center),
    []
  );

  return (
    <div className="global-dashboard__content">
      <div className="white-background header">
        <img src={logo} alt="ICMEC" className="nav-bar-logo" />
        <h1>Global Dashboard</h1>
        <p className="last-update">Last update was at {lastUpdate}</p>
      </div>
      <GDStatistic
        className="latest-cases"
        title="Latest Cases"
        stat={stats.latestCases}
        description={`Created in the previous ${stats.lastHoursUpdate} hours`}
      />
      <GDStatistic
        className="latest-alerts"
        title="Latest Alerts"
        stat={stats.latestAlerts}
        description={`Issued in the previous ${stats.lastHoursUpdate} hours`}
      />
      <GDStatistic
        className="new-alerts"
        title="Total Alerts Issued"
        stat={stats.alertsIssued}
        description={`Total in ${currentYear}`}
      />
      <GDStatistic
        className="impressions"
        title="Poster Impressions"
        stat={stats.impressions}
        description={`Total Media Impressions in ${currentYear}`}
      />
      <GDStatistic
        className="click-numbers"
        title="People Engaged"
        stat={stats.engagedPeople}
        description={`Clicks Through Rate in ${currentYear}`}
      />
      <GDStatistic
        className="closed-percentage"
        title="Alerted Cases Closed"
        stat={stats.closedNumber}
        description={`${stats.closedPercentage}% of ${stats.casesWithAlerts} alerted cases`}
      />
      <div className="heatmap white-background">
        <Heatmap
          agencyCode={'ALL'}
          state={''}
          markerCenter={currenCenter || undefined}
        />
      </div>
      <GDTable
        className="cases-by-country"
        title="Cases By Country"
        stats={stats.casesByCountry}
      />
      <GDTable
        className="alerts-by-country"
        title="Alerts By Country"
        stats={stats.alertsByCountry}
      />
      <div className="cases-by-week white-background">
        <h2>Weekly Cases</h2>
        <DatesChart
          data={stats.casesByWeek}
          dataKey={'cases'}
          weekDay={true}
          strokePrimary={true}
          height="80%"
        />
      </div>
      <GDCarousel
        recentCases={stats.recentCases}
        onTransition={handleTransition}
      />
    </div>
  );
};

export default GlobalDashboard;



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Global/GlobalDashboard.tsx